<template>
  <div
    class="modal fade"
    tabindex="-1"
    ref="dialogModal"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog" :class="size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button
            type="button"
            class="close btn btn-secondary"
            aria-label="Close"
            @click="closeModal"
          >
          <i class="fas fa-times"></i>
            <!-- <span aria-hidden="true">&times;</span> -->
          </button>
        </div>
        <div class="modal-body" :style="[bodyStyle]" >
          <slot></slot>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-secondary btn-sm float-left"
            @click="closeModal"
          >
            關閉
          </button>
          <button
            type="button"
            class="btn btn-sm"
            :class="{
              'btn-primary': mode !== 'delete',
              'btn-danger': mode === 'delete'
            }"
            v-show="showUpdateButton"
            @click="$emit('update-button-click')"
          >
            {{ checkButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
export default {
  data() {
    return {
      isActive: true,
      bodyStyle: '',
      bodyMarginAuto: {margin: 'auto'},
      bodyCenter: {
        display: 'block',
        margin: 'auto'
      }
    }
  },
  props: [
    'modalTitle',
    'mode',
    'modalSize',
    'showUpdateButton',
    'customUpdateButton',
    'isImage',
    'isMarginAuto'
  ],
  name: 'dialog-modal',
  computed: {
    checkButtonText() {
      if (this.customUpdateButton) return this.customUpdateButton
      if (this.mode === 'delete') return '確認刪除'
      return 'save'
    },
    size() {
      return `modal-${this.modalSize}`
    }
  },
  methods: {
    openModal() {
      $(this.$refs.dialogModal).modal('show')
    },
    closeModal() {
      $(this.$refs.dialogModal).modal('hide')
    }
  },
  mounted() {
    $(this.$refs.dialogModal).on('shown.bs.modal', e => {
      this.$emit('dialog-opend')
    })
    $(this.$refs.dialogModal).on('hidden.bs.modal', e => {
      this.$emit('dialog-close')
    })

    if (this.isMarginAuto) {
      this.bodyStyle = this.bodyMarginAuto
    }

    if (this.isImage) {
      this.bodyStyle = this.bodyCenter
    }
  }
}
</script>

<style >
</style>
